import { InformationHoverIcon } from "./InformationHoverIcon";

type Props = {
  title: string;
  value: string | number;
  colSpan?: number;
  info?: string;
  subtitle?: string;
};

const MainStatCard = ({ title, value, colSpan, info, subtitle }: Props) => (
  <div
    className="h-full rounded-2xl border border-border bg-card p-6"
    style={{ gridColumn: colSpan ? `span ${colSpan}` : undefined }}
  >
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-1.5">
        <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        {info && <InformationHoverIcon information={info} />}
      </div>
      <p className="text-4xl font-bold leading-none text-palomma-secondary">{value}</p>
      {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
    </div>
  </div>
);

export default MainStatCard;
